module.exports = __webpack_public_path__ + "img/05-mayo-banner.2d55ad29.jpg";